import { Flex, Text } from '@chakra-ui/react';
import { AngularNavLink } from './AngularNavLink';

export interface PageBreadcrumbItem {
  label: string;
  navObj?: Record<string, unknown>;
  route?: string;
}

interface PageBreadcrumbProps {
  items: PageBreadcrumbItem[];
  label: string;
}

export function PageBreadcrumb({ items, label }: PageBreadcrumbProps) {
  return (
    <Flex align="center" aria-label={label} as="nav" gap="9px" minH="28px">
      {items.map((item, index) => (
        <Flex align="center" gap="9px" key={`${item.label}-${index}`}>
          {index > 0 && (
            <Text color="entityDirectory.mutedText" fontSize="12px">
              ›
            </Text>
          )}
          {item.route ? (
            <AngularNavLink
              color="entityDirectory.mutedText"
              fontSize="12px"
              navobj={item.navObj}
              textDecoration="none"
              to={item.route}
              variant="unstyled"
              _hover={{ color: 'entityDirectory.text' }}
            >
              {item.label}
            </AngularNavLink>
          ) : (
            <Text color="entityDirectory.text" fontSize="12px">
              {item.label}
            </Text>
          )}
        </Flex>
      ))}
    </Flex>
  );
}
